import React from 'react';
import styles from './ChipBadge.module.scss';
import Typography from '@mui/material/Typography';

interface ChipBadgeProps {
  label: string;
  dot?: boolean;
  round?: boolean;
  className?: string;
  color?: 'success' | 'warning' | 'primary' | 'error' | 'secondary' | 'disabled' | 'danger';
  variant?: 'filled' | 'outlined';
}

export function ChipBadge(props: ChipBadgeProps) {
  const { label, color = 'primary', variant = 'filled' } = props;
  return (
    <div
      className={[
        styles.container,
        styles['container_' + color],
        styles['variant_' + variant],
        props.round ? styles.container_round : '',
        props.className,
      ].join(' ')}
    >
      <Typography className={styles.label} variant="caption">
        {label}
      </Typography>
    </div>
  );
}
